import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeResourceFromPlanzone(
    request: Boundaries["removeResourceFromPlanzone"]["request"],
  ): void;
}

function useRemoveResourceFromPlanzone(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveResourceFromPlanzoneRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveResourceFromPlanzoneRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveResourceFromPlanzoneRequestFailure(resource),
    ),
    removeResourceFromPlanzone: core.removeResourceFromPlanzone,
  };
}

export { useRemoveResourceFromPlanzone };
